/** Isolated risk helpers for Assessment Reports edit only (not shared with Materiality.js). */

export function reportsEditClampScore(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return 5;
  return Math.min(10, Math.max(1, Math.round(v * 10) / 10));
}

export function reportsEditRiskCategory(score) {
  const n = reportsEditClampScore(score);
  if (n <= 3.3) return 'LOW';
  if (n <= 6.6) return 'MODERATE';
  return 'HIGH';
}

export const REPORTS_EDIT_SOX_CYCLES = [
  { code: 'ELC', name: 'Entity Level Controls', description: 'Organization-wide controls' },
  { code: 'FSC', name: 'Financial Statement Close Process', description: 'Financial close & consolidations' },
  { code: 'ER', name: 'External Reporting', description: 'External financial reporting' },
  { code: 'OTC', name: 'Order to Cash', description: 'Revenue and receivables' },
  { code: 'TRS', name: 'Treasury', description: 'Cash and treasury management' },
  { code: 'DBT', name: 'Debt', description: 'Debt obligations and management' },
  { code: 'PTP', name: 'Procure to Pay', description: 'Purchasing and payables' },
  { code: 'HTR', name: 'Hire to Retire', description: 'Payroll and human resources' },
  { code: 'INV', name: 'Inventory', description: 'Inventory management' },
  { code: 'TAX', name: 'Tax', description: 'Tax calculations and filings' },
  { code: 'FIX', name: 'Fixed Assets', description: 'Property and equipment' },
  { code: 'LEA', name: 'Leases', description: 'Lease accounting' },
  { code: 'EQY', name: 'Equity', description: 'Stock admin & equity' },
];

/** Same cycle badge colors as assessment / reports display (OTC green, etc.). */
export function reportsEditSoxCycleColor(code) {
  const colors = {
    ELC: 'bg-purple-100 text-purple-700 border-purple-200',
    FSC: 'bg-indigo-100 text-indigo-700 border-indigo-200',
    ER: 'bg-blue-100 text-blue-700 border-blue-200',
    OTC: 'bg-green-100 text-green-700 border-green-200',
    TRS: 'bg-teal-100 text-teal-700 border-teal-200',
    DBT: 'bg-cyan-100 text-cyan-700 border-cyan-200',
    PTP: 'bg-orange-100 text-orange-700 border-orange-200',
    HTR: 'bg-pink-100 text-pink-700 border-pink-200',
    INV: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    TAX: 'bg-red-100 text-red-700 border-red-200',
    FIX: 'bg-lime-100 text-lime-700 border-lime-200',
    LEA: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    EQY: 'bg-violet-100 text-violet-700 border-violet-200',
  };
  return colors[code] || 'bg-gray-100 text-gray-700 border-gray-200';
}

export function reportsEditValidateCustomSoxCycle(codeRaw, nameRaw, standardCycles, customCycles) {
  const code = String(codeRaw ?? '').trim().toUpperCase();
  const name = String(nameRaw ?? '').trim();
  if (!code || !name) return 'Please enter both a cycle code and a name.';
  if (code.length > 3) return 'Cycle code must be 3 characters or fewer.';
  const pool = [...(standardCycles || []), ...(customCycles || [])];
  if (pool.some((c) => String(c.code).toUpperCase() === code)) {
    return `Cycle code "${code}" already exists.`;
  }
  const nameNorm = name.toLowerCase();
  if (pool.some((c) => String(c.name || '').trim().toLowerCase() === nameNorm)) {
    return 'A cycle with that name already exists.';
  }
  return null;
}

export const REPORTS_EDIT_BS_CATEGORIES = ['asset', 'liability', 'equity'];
export const REPORTS_EDIT_IS_CATEGORIES = ['revenue', 'expense'];
